/**
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

var id            = 'pClear',
    Page          = require('stb-component-page'),
    page          = new Page({$node: document.getElementById(id)}),
    systemPlayer  = require('../modules/system.player'),
    Panel         = require('stb-component-panel'),
    app           = require('mag-app'),
    keys          = require('stb-keys'),
    checkAppByPid = require('../modules/tools').checkAppByPid,
    exitTS        = require('../modules/exit.timeshift'),
    showExitModal = require('../modules/ui/exit.modal')(page),
    panel = new Panel({
        focusable: true
    });


page.panel = panel;
page.add(panel);

page.addListeners({
    keydown: function ( event ) {
        switch ( event.code ) {
            case keys.ok:
                app.route(app.pages.main);
                break;
            case keys.back:
                if ( app.currentIntent.data.exitWithConfirm ) {
                    showExitModal(function ( exitState ) {
                        if ( exitState ) {
                            app.currentIntent.close(true);
                            app.emit('close');
                            exitTS();
                            systemPlayer.primary.stop();
                        }
                    });
                } else if ( app.currentIntent.data.persistent && checkAppByPid(app.currentIntent.creator) ) {
                    // same as we click list button
                    app.currentIntent.show(app.currentIntent.creator, {reasonToggleView: true});
                } else {
                    app.currentIntent.close();
                    exitTS();
                    systemPlayer.primary.stop();
                    app.emit('close');
                }
                break;
            case keys.left:
                app.rewind(false);
                break;
            case keys.right:
                app.rewind(true);
                break;
            case keys.up:
                app.nextPrevContent(true);
                break;
            case keys.down:
                app.nextPrevContent(false);
                break;
        }
    },
    click: function () {
        app.route(app.pages.main);
    },
    show: function () {
        panel.focus();
    }
});


module.exports = page;
